import React from "react";
//import MenuExperiance from "../components/MenuExperience";
import MainMenu from "../components/MainMenu";
import SoftMenu from "../components/SoftMenu";
import ChaiBar from "../components/ChaiBar";
import SevenIslandMenu from "../components/SevenIslandMenu";
import ReservationBanner from "../components/ReservationBanner";
const OurMenu = () => {
  return (
    <div>
      {/* <MenuExperiance /> */}

      <SoftMenu />
      <ChaiBar />
      <SevenIslandMenu />
      <ReservationBanner />
    </div>
  );
};

export default OurMenu;
